const moneyFilter = require("./moneyFilter")
const rubleFilter = require("./rubleFilter")